import React from 'react'
import { Badge, Nav, NavItem } from 'react-bootstrap'
import { IProgram } from '../../store/program/interfaces'
import { generateProgramDateData } from '../../utils'

const ProgramDateNavItems = (props: {
    program: IProgram
}) => {

    const { registrationStartMoment, registrationEndMoment, afterRegistrationEnd, afterRegistrationStart } = generateProgramDateData(props.program)

    return (
        <>
            {(registrationStartMoment && !(afterRegistrationEnd > 0)) &&
                <NavItem className='mr-2'>
                    {afterRegistrationStart > 0 ? (
                        <Badge pill variant='success'>
                            <>Anmeldestart war am {registrationStartMoment}</>
                        </Badge>
                    ) : (
                        <Badge pill variant='warning'>
                            <>Anmeldestart ist am {registrationStartMoment}</>
                        </Badge>
                    )}
                </NavItem>
            }
            {registrationEndMoment &&
                <NavItem className='mr-2'>
                    {afterRegistrationEnd > 0 ? (
                        <Badge pill variant='warning'>
                            <>Anmeldeschluss war am {registrationEndMoment}</>
                        </Badge>
                    ) : (
                        <Badge pill variant='success'>
                            <>Anmeldeschluss ist am {registrationEndMoment}</>
                        </Badge>
                    )}
                </NavItem>
            }
        </>
    )
}

export default ProgramDateNavItems
